/* =========================================================
   Odyss Blog — interactions
   - Klaviyo email signup (sidebar + full-width)
   - Smooth interactions for category nav (mobile scroll)
   ========================================================= */

(function () {
  'use strict';

  var KLAVIYO_ENDPOINT =
    'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim());
  }

  function show(el) { if (el) el.removeAttribute('hidden'); }
  function hide(el) { if (el) el.setAttribute('hidden', ''); }

  function findSibling(form, className) {
    if (!form || !form.parentElement) return null;
    var children = form.parentElement.children;
    for (var i = 0; i < children.length; i++) {
      if (children[i] !== form && children[i].classList.contains(className)) {
        return children[i];
      }
    }
    return null;
  }

  function getErrorEl(form) {
    return form.querySelector('.odyss-klaviyo-form__error');
  }

  function getSuccessEl(form) {
    var inside = form.querySelector('.odyss-klaviyo-form__success');
    if (inside) return inside;
    return findSibling(form, 'odyss-klaviyo-form__success');
  }

  function setError(form, message) {
    var err = getErrorEl(form);
    if (!err) return;
    err.textContent = message;
    show(err);
  }

  function clearError(form) {
    var err = getErrorEl(form);
    if (!err) return;
    err.textContent = '';
    hide(err);
  }

  function getPreSuccessModal(form) {
    if (!shouldShowPreSuccessModal(form)) return null;
    var page = form.closest('[data-section-type="odyss-pre-page"]');
    if (page) return page.querySelector('[data-opre-success-modal]');
    if (form.classList.contains('odyss-klaviyo-form--pre') ||
        form.classList.contains('odyss-klaviyo-form--pre-footer')) {
      return document.querySelector('[data-opre-success-modal]');
    }
    return null;
  }

  function shouldShowPreSuccessModal(form) {
    return form && form.dataset.successModalEnabled === 'true';
  }

  function getSuccessRedirectUrl(form) {
    return form && form.dataset.successRedirectUrl ? form.dataset.successRedirectUrl.trim() : '';
  }

  function showPreSuccessModal(form) {
    var modal = getPreSuccessModal(form);
    if (!modal) return false;
    var button = modal.querySelector('[data-opre-success-close]');
    modal.removeAttribute('hidden');
    document.documentElement.classList.add('opre-modal-open');
    if (button) button.focus({ preventScroll: true });
    return true;
  }

  function hidePreSuccessModal(modal) {
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.documentElement.classList.remove('opre-modal-open');
  }

  function setFormLoading(form, button, isLoading) {
    if (!form || !button) return;
    if (!button.dataset.odyssOriginalText) {
      button.dataset.odyssOriginalText = button.textContent;
    }

    form.classList.toggle('is-loading', isLoading);
    form.setAttribute('aria-busy', isLoading ? 'true' : 'false');

    if (isLoading) {
      button.setAttribute('disabled', 'disabled');
      button.textContent = 'Loading...';
    } else {
      button.removeAttribute('disabled');
      button.textContent = button.dataset.odyssOriginalText;
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
    var form = event.currentTarget;
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var listId = form.dataset.klaviyoList;
    var source = form.dataset.klaviyoSource || 'blog';

    if (form.classList.contains('is-loading')) return;

    clearError(form);

    if (!input) return;
    var email = input.value.trim();

    if (!isValidEmail(email)) {
      setError(form, 'Please enter a valid email address.');
      input.focus();
      return;
    }

    if (!listId) {
      console.warn('[odyss-blog] Klaviyo list ID not configured for form:', form);
      setError(form, 'Subscription is temporarily unavailable. Please try again later.');
      return;
    }

    setFormLoading(form, button, true);

    var body = new URLSearchParams();
    body.append('g', listId);
    body.append('email', email);
    body.append('$source', source);

    fetch(KLAVIYO_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString(),
      mode: 'no-cors'
    })
      .then(function () {
        var successModal = getPreSuccessModal(form);
        var successRedirectUrl = getSuccessRedirectUrl(form);

        if (successModal) {
          form.reset();
          setFormLoading(form, button, false);
          showPreSuccessModal(form);
        } else {
          var success = getSuccessEl(form);
          setFormLoading(form, button, false);
          form.style.display = 'none';
          show(success);
        }

        if (window.OdyssConsent && window.OdyssConsent.analyticsAllowed &&
            window.dataLayer && typeof window.dataLayer.push === 'function') {
          window.dataLayer.push({
            event: 'newsletter_signup',
            form_source: source,
            list_id: listId
          });
        }

        if (!successModal && successRedirectUrl) {
          window.location.href = successRedirectUrl;
        }
      })
      .catch(function (err) {
        console.error('[odyss-blog] Klaviyo subscription failed:', err);
        setError(form, 'Something went wrong. Please try again.');
        setFormLoading(form, button, false);
      });
  }

  function initKlaviyoForms(scope) {
    var root = scope || document;
    var forms = root.querySelectorAll('.odyss-klaviyo-form');
    forms.forEach(function (form) {
      if (form.dataset.odyssBound === '1') return;
      form.dataset.odyssBound = '1';
      form.addEventListener('submit', handleSubmit);
    });

    var preModals = root.querySelectorAll('[data-opre-success-modal]');
    preModals.forEach(function (modal) {
      if (modal.dataset.odyssBound === '1') return;
      modal.dataset.odyssBound = '1';
      modal.addEventListener('click', function (event) {
        if (event.target === modal || event.target.hasAttribute('data-opre-success-close')) {
          hidePreSuccessModal(modal);
        }
      });
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var modal = document.querySelector('[data-opre-success-modal]:not([hidden])');
    if (modal) hidePreSuccessModal(modal);
  });

  function initCategoryNav(scope) {
    var root = scope || document;
    var navs = root.querySelectorAll('.odyss-category-nav');
    navs.forEach(function (nav) {
      var active = nav.querySelector('.odyss-category-nav__item--active');
      if (active && typeof active.scrollIntoView === 'function') {
        try {
          active.scrollIntoView({ behavior: 'auto', inline: 'center', block: 'nearest' });
        } catch (e) {
          // ignore older browsers
        }
      }
    });
  }

  function compareAggregateItems(left, right) {
    var publishedAtDifference =
      Number(right.dataset.odyssPublishedAt || 0) -
      Number(left.dataset.odyssPublishedAt || 0);

    if (publishedAtDifference !== 0) return publishedAtDifference;
    return String(left.dataset.odyssArticleUrl || '').localeCompare(
      String(right.dataset.odyssArticleUrl || '')
    );
  }

  function initAggregateGrids(scope) {
    var root = scope || document;
    var grids = root.querySelectorAll('[data-odyss-aggregate-grid]');

    grids.forEach(function (grid) {
      var cards = Array.prototype.slice.call(
        grid.querySelectorAll('[data-odyss-aggregate-card]')
      );

      cards.sort(compareAggregateItems);
      cards.forEach(function (card) {
        card.hidden = false;
        grid.appendChild(card);
      });

      var section = grid.closest('[data-section-type="odyss-blog-grid"]');
      if (!section) return;

      var candidates = Array.prototype.slice.call(
        section.querySelectorAll('[data-odyss-featured-candidate]')
      );
      candidates.sort(compareAggregateItems);
      candidates.forEach(function (candidate, index) {
        candidate.hidden = index !== 0;
      });

      if (candidates.length === 0) return;
      var featuredUrl = candidates[0].dataset.odyssArticleUrl;
      var matchingCard = cards.find(function (card) {
        return card.dataset.odyssArticleUrl === featuredUrl;
      });
      if (matchingCard) matchingCard.hidden = true;
    });

    if (grids.length > 0 && window.AOS && typeof window.AOS.refreshHard === 'function') {
      requestAnimationFrame(function () {
        window.AOS.refreshHard();
      });
    }
  }

  function init(scope) {
    initKlaviyoForms(scope);
    initCategoryNav(scope);
    initAggregateGrids(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Re-bind when Shopify theme editor loads/updates a section
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
